import styled from 'styled-components'
import Flex from 'components/Flex'

export const Container = styled(Flex)`
  width: 100%;
  height: 100vh;
  background-color: #fafafb;
  max-height: 100vh;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`

export const SubContainer = styled(Flex)`
  width: 25%;
  margin-top: 100px;
  margin-left: 8%;
`
export const ProgressContainer = styled(Flex)`
  width: 25%;
  justify-content: end;
  align-items: center;
  height: 80vh;
`

export const Wrapper = styled(Flex)`
  width: 50%;
  margin-top: 32px;
`

export const Left = styled.div`
  margin-top: 75px;
  width: 40%;
  height: auto;
  position: absolute;
  background-color: #fafafb;
`

export const Right = styled.div`
  margin-top: 20px;
  width: 60%;
  height: auto;
  padding-top: 15px;
  right: 300px;
  position: absolute;
`

export const H2 = styled.div`
  font-weight: 700;
  font-size: 1.2857142857142858em;
  line-height: 24px;
  color: #4d566e;
  margin-top: ${props => (props.marginTop ? props.marginTop : null)};
`

export const Heading = styled.div`
  font-weight: 700;
  font-size: 1.7em;
  line-height: 30px;
  color: #1b1f22;
`

export const Content = styled.div`
  margin-top: 33px;
  box-shadow: 0px 4px 12px rgba(153, 153, 153, 0.1);
  border-radius: 10px;
  width: 100%;
  background-color: #ffffff;
  padding: 50px 75px;
`
export const ValidateMessage = styled.div`
  font-weight: 500;
  font-size: 0.8em;
  color: red;
`

export const ProgroressBar = styled.div`
  width: 10%;
  position: fixed;
`
